import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { DealProcessingEvents } from '@common/model/processing';
import { AdminProcessingApiTag, adminProcessingApi, useProcessingSocket } from 'src/entities/processing';

export const useProcessingRealtime = (): void => {
  const dispatch = useDispatch();
  const socket = useProcessingSocket();

  useEffect(() => {
    const handleUpdate = () => {
      dispatch(adminProcessingApi.util.invalidateTags([AdminProcessingApiTag.Counters]));
    };

    socket.on(DealProcessingEvents.Updated, handleUpdate);

    return () => {
      socket.off(DealProcessingEvents.Updated, handleUpdate);
    };
  }, [dispatch, socket]);
};
